module.exports = __webpack_public_path__ + "img/az.93d4994b.svg";